<template lang="">
<div class="obitCard_wrap">
    <div class="obitCard">
        <div class="section section_1 type1">
            <div class="img_wrap">
                <img src="../../../assets/images/common/obitcard_img_01.png" alt="">
                <div class="txt_wrap">
                    <p>
                        故 {{ funeralInfo.deceasedName }}님께서 {{ $localizeDate(funeralInfo.deathBedDate, false) }} 별세하셨음을 <br>
                        삼가 알려드립니다.
                    </p>
                    <p v-html="funeralInfo.greetingsMessage"></p>
                </div>
            </div>
            <div class="txt_box">
                <h5>삼가 故人의 冥福을 빕니다.</h5>
                <p class="date">별세 : {{ $localizeDate(funeralInfo.deathBedDate, true) }} ({{ $getDayName(funeralInfo.deathBedDate, false) }}) {{ funeralInfo.deathBedTime }} 09시 30분</p>
                <p class="location">{{ funeralInfo.funeralLocationName }} {{ funeralInfo.funeralLocationDtl }}</p>
            </div>
        </div>
        <div class="section section_2">
            <div class="tbl_wrap">
                <table class="tbl_obit">
                    <tbody>
                        <tr>
                            <th>고인</th>
                            <td><div class="deceased">故{{ funeralInfo.deceasedName }} ( 향년 {{ funeralInfo.age }}세 )</div></td>
                        </tr>
                        <tr>
                            <th class="sangju">상주</th>
                            <td>
                                <p v-html="funeralInfo.mourners"></p>
                            </td>
                        </tr>
                        <tr>
                            <th>별세</th>
                            <td>
                                <p>{{ $localizeDate(funeralInfo.deathBedDate, true) }} ({{ $getDayName(funeralInfo.deathBedDate, false) }}) {{ funeralInfo.deathBedTime }}</p>
                            </td>
                        </tr>
                        <tr>
                            <th>발인</th>
                            <td>
                                <p>{{ $localizeDate(funeralInfo.funeralDate, true) }} ({{ $getDayName(funeralInfo.funeralDate, false) }}) {{ funeralInfo.funeralTime }}</p>
                            </td>
                        </tr>
                        <tr>
                            <th>빈소</th>
                            <td>
                                <p>{{ funeralInfo.funeralLocationName }} {{ funeralInfo.funeralLocationDtl }}</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="img_wrap"  v-if="hasMainThumbnail">
                <div class="preview">
                    <img :src="$getImgUrl(funeralInfo.attachList[selectedThumbnailIdx])" alt="">
                    <div class="preview_btn">
                        <a @click="changeMainThumbnail('prev')" class="btn_prevImg"></a>
                        <a @click="changeMainThumbnail('next')" class="btn_nextImg"></a>
                    </div>
                </div>
                <ul class="thumb">
                    <li v-for="(attach, index) in funeralInfo.attachList" @click="selectThumbnail(index)"><img :src="$getImgUrl(attach)" alt="" style="width: 100%"></li>
                </ul>
            </div>
        </div>
        <div class="section section_3" style="background:#fff;">
            <div class="tit">
                {{ funeralInfo.funeralInfoTitle }}
            </div>
            <p class="txt">
                {{ funeralInfo.funeralInfoDtl }}
            </p>
        </div>
        <hr class="divider">
        <div class="section section_4">
            <div class="tit">
                안내 사항
            </div>
            <p class="txt mt15 padding030">
                {{ funeralInfo.noticeMessage }}
            </p>
            <!-- <ul>
                <li v-for="mourner in funeralInfo.mournerList">
                    <b>{{ mourner.name }}</b> ({{ mourner.bankName }} {{ mourner.bankInfo }})
                </li>
            </ul> -->
        </div>
        <div class="section section_5" v-if="funeralInfo.campaign.campaignSeq">
            <div class="tit">
                디지털 기부 화환
            </div>
            <p class="txt">
                디지털 기부 화환은 화환을 디지털 형태로 <br>
                제공 되는 서비스입니다. <br>
                디지털 화환의 결제 금액의 일부는 다양한 <br>
                사회적 활동에 기부가 됩니다.
            </p>
            <div class="box">
                <div class="img_wrap">
                    <img :src="$getImgUrl(campaignThumbnail)" alt="">
                </div>
                <div class="txt_wrap">
                    <h5>[후원캠페인]</h5>
                    <p>
                        {{ funeralInfo.campaign.campaignName }}
                    </p>
                    <div>기본 운영비 <span>{{ $addComma(funeralInfo.campaign.campaignAmount) }}원</span></div>
                </div>
            </div>
            <div class="btn_wrap">
                <a class="btn_view" @click.prevent="goByPath('/overview')">자세히 보기</a>
                <a class="btn_support" @click.prevent="goByPath('/campaign/campaign-dtl/' + funeralInfo.campaign.campaignSeq)">캠페인 안내</a>
            </div>
        </div>
        <div class="section section_6">
            <div class="tit">
                오시는 길
            </div>
            <p class="txt">
                {{ funeralInfo.funeralLocationName }} <br>
                {{ funeralInfo.mapAddress }}
            </p>
            <div class="map_wrap">
                <div id="map">
                    지도
                </div>
            </div>
        </div>
    </div>
</div>

<aside id="aside" class="fix_navi">
	<ul class="row">
		<li><button type="button" @click="makeMournerBank">부의금</button></li>
		<li><button class="brown" @click="makePayment" >디지털 기부 화환</button></li>
        <li><button class="button" @click="makePop" >일반 화환 </button></li>
	</ul>
</aside>

</template>

<script>
export default {
    props: {
        funeralInfo: {
            type: Object,
            required: true
        },
        invitationSeq: {
            type: String
        }
    },

    data () {
        return {
            selectedThumbnailIdx: 0,
        }
    },

    methods: {
        selectThumbnail (i) {
            this.selectedThumbnailIdx = i;
        },

        changeMainThumbnail (direction) {
            if (direction == 'prev' && this.selectedThumbnailIdx != 0) {
                this.selectedThumbnailIdx -= 1
            } else if (direction == 'next' && this.selectedThumbnailIdx != this.funeralInfo.attachList.length - 1){
                this.selectedThumbnailIdx += 1
            }
        },

        makePayment () {
            const paymentAmount = this.funeralInfo.campaign.campaignAmount
            const campaignName = this.funeralInfo.campaign.campaignName
            const invitationSeq = this.invitationSeq
            this.$openModal('paymentModal', {
                paymentAmount: paymentAmount,
                campaignName: campaignName,
                invitationSeq: invitationSeq,
                invitationType: 'F'
            })
        },

        makeMournerBank () {
            const list = Array.isArray(this.funeralInfo.mournerList)
                ? this.funeralInfo.mournerList
                : [];
            console.log('[Parent] mournerList 전달 직전:', list);
            console.log('[Parent] mournerList 전달 직전 2 :', JSON.parse(JSON.stringify(list)));
            this.$openModal('mournerBankModal', {
                mournerList: JSON.parse(JSON.stringify(list))
            })
        },

        //일반 화환 사이트로 이동
        makePop() {
            this.$openGeneralFlowerSite(this.funeralInfo.funeralLocationName)
        },

        //경로 이동
        goByPath(path) {
            const {href} = this.$router.resolve({ path });
            window.open(href, '_blank' );
        },

        initMap (x, y, name) {
            var container = document.getElementById('map');
            var options = {
                center: new kakao.maps.LatLng(x, y),
                level: 4,
                draggable: false
            };
            this.map = new kakao.maps.Map(container, options);
            this.marker = new kakao.maps.Marker({
                position: options.center,
                map: this.map,
            });
            if (name) {
                this.infoWindow = new kakao.maps.InfoWindow({
                    content: `<div style="padding:5px;font-size:14px;">${name}</div>`,
                });
                this.infoWindow.open(this.map, this.marker);
            }
        },
    },

    mounted () {
        this.initMap(this.funeralInfo.funeralLatitude, this.funeralInfo.funeralLongitude, this.funeralInfo.funeralLocationName)
    },

    computed: {
        campaignThumbnail() {
            return this.funeralInfo?.campaign?.campaignThumbnailPath || '';
        },

        hasMainThumbnail() {
            return (
            this.funeralInfo &&
            Array.isArray(this.funeralInfo.attachList) &&
            this.funeralInfo.attachList[this.selectedThumbnailIdx]
            );
        }    
    }
}
</script>
<style>

</style>